import { useContext } from 'react';
import { LookupsContext, ILookupsContext } from './LookupsContext';

export const useLookups = () => useContext<ILookupsContext>(LookupsContext);
